<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 支付结果确认框
 * @Date: 2021-09-10 13:57:24
 * @LastEditTime: 2021-09-29 17:29:55
-->
<template>
  <van-dialog v-model:show="showData" class="payTypes-dialog">
    <van-icon name="clear" class="close" @click="closeDialog" />
    <template #title>
      <div class="vant-title pl-15 text-lm">
        Complete Payment
      </div>
    </template>

    <div class="vant-content pl-15 pr-15 mt-10 mb-10 text-main text-sm">
      <div class="flex justify-center"><van-loading color="#0094ff" /></div>
      <div class="mt-10">Wait for a moment while we are confirming your payment result.</div>
    </div>
    
    <template #footer>
      <div class="vant-obn text-main  text-lm mt-10 mb-10 flex justify-center">
        <van-button type="success" size="small" @click="confirm">Confirm</van-button>
      </div>
      <div class="vant-desc  text-sm ml-15 mb-10">
        <van-icon name="warning" /> Having any problems in processing? Please check the <a href="https://asoworld.com/faq/payment/" target="_blank">payment guide</a>.
      </div>
    </template>
   
  </van-dialog>
</template>

<script>
import { ref } from '@vue/reactivity'
export default {
  props:{
    show:{
      type:Boolean,
      default:()=>false
    }
  },
  setup(props,{emit}){
    const showData = ref(props.show)
    const confirm = ()=>{
      emit('confirm')
    }

    const closeDialog=()=>{
      emit('closeDialog')
    }

    return {confirm,closeDialog,showData}
  }
}

</script>
<style lang="scss" scoped>
.close {
  position: absolute;
  right: 3px;
  top: 3px;
  color: #666;
}
</style>